import { createActions } from 'reduxsauce';

export const { Types: types, Creators: actions } = createActions({
    requestDeleteOrderOut: ['id'],
    deleteOrderOutSucceeded: ['id'],
    deleteOrderOutFailed: ['error'],
});

const removeSelectedItem = (items, deletedItemId, identityKey = 'order_unique_id') =>
    items.filter((item) => item[identityKey] !== deletedItemId);

export default {
    [types.REQUEST_DELETE_ORDER_OUT]: (state, { id }) => ({
        ...state,
        delete: {
            ...state.delete,
            id,
            loading: true,
            error: null,
        },
    }),
    [types.DELETE_ORDER_OUT_SUCCEEDED]: (state, { id }) => ({
        ...state,
        data: removeSelectedItem(state.data, id),
        delete: {
            ...state.delete,
            id: null,
            loading: false,
        },
    }),
    [types.DELETE_ORDER_OUT_FAILED]: (state, { error }) => ({
        ...state,
        delete: {
            ...state.delete,
            id: null,
            loading: false,
            error,
        },
    }),
};
